module.exports = __webpack_public_path__ + "static/media/entname_left.cb7f4728.svg";